import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EpochDatetimeLocalDirective } from './epoch-datetime-local.directive';
import { FormatDatePipe } from './pipes/format-date.pipe';

@NgModule({
  declarations: [EpochDatetimeLocalDirective],
  imports: [CommonModule, FormatDatePipe],
  exports: [EpochDatetimeLocalDirective, FormatDatePipe], // <-- export so other modules can use it
})
export class SharedModule {}
